import AuthTokenExpiredError from './AuthTokenExpiredError'

export default class GuestReestablishRequiredError extends AuthTokenExpiredError {
  constructor(message, meta = {}) {
    super(message)
    this.name = 'GuestReestablishRequiredError'
    this.code = 'guest_reestablish_required'
    this.meta = meta && typeof meta === 'object' ? meta : {}
  }
}
